import { IApplicationState } from '../../types/redux';

export function getDocumentation(state: IApplicationState) {
  return state.developer.documentation;
}
